<template lang="pug">
  .b-project-detail
    ._container
      ._image-wrap
        AvatarEditable._image(:avatar="project.avatar" :editable="false" placeholder="no-avatar-project")
      ._left
        h1._title {{ project.name }}
          ._label.-green(v-if="access.isProjectAuthor(true) && !noAuth") Мой проект
          ._label.-yellow(v-if="project.isTemplate") Шаблон
        address._address(v-if="project.objectAddress")
          Icon(name="map")
          | {{ project.objectAddress }}
        ._progress-container
          BaseProgressbar._progressbar(styling="header" v-bind="dateProgress" :color="progressbarColor")
          ._progress-tooltip(v-if="dateProgress.label") {{ dateProgress.label }}
      ._right
        ._menu(v-if="!noAuth")
          Bookmark(light category="project" :id="project['@id']")
          EllipsisMenu(light :items="ellipsisMenuItems")
        ._button.project-detail-button(v-if="!project.companyDepartment")
        template(v-else)
          template(v-if="!companyXl")
            ._company
              .b-company-tile-sm
                AvatarEditable._avatar(:avatar="project.companyDepartment.company.avatar" :editable="false" placeholder="no-avatar-project")
                router-link(:to="{ name: 'company-departments', params: { companyId: project.companyDepartment.company.id } }")._company {{ project.companyDepartment.company.name }}
                ._department {{ project.companyDepartment.name }}
            ._button.project-detail-button
          .b-company-tile-xl._company-xl(v-else)
            AvatarEditable._avatar(:avatar="project.companyDepartment.company.avatar" :editable="false" placeholder="no-avatar-project")
            ._name {{ project.companyDepartment.company.name }}
            ._contacts {{ project.companyDepartment.company.contacts }}


</template>

<script>
import Access from '@/utils/access';
import dateProgress from '@/utils/dateProgress';
import projectModel from '@/model/project';

import BaseProgressbar from '@/components/BaseProgressbar.vue';
import EllipsisMenu from '@/components/EllipsisMenu.vue';
import AvatarEditable from '@/components/AvatarEditable.vue';

export default {
  name: 'ProjectDetail',
  components: { AvatarEditable, EllipsisMenu, BaseProgressbar }, // eslint-disable-line
  props: {
    project: {
      type: Object,
      required: true,
    },
    noAuth: Boolean,
    companyXl: Boolean,
  },
  data() {
    return {
    };
  },
  computed: {
    access() { return new Access(this.project, this.$store.state.auth.user); },
    isProjectCompleted() { return this.project.numberOfOpenedTasks === 0;},
    dateProgress() { return dateProgress(this.project.dateStart, this.project.dateFinish, this.project.archivedAt, false, this.isProjectCompleted); },
    progressbarColor() {
      if (this.project.isArchived) {
        return 'grey';
      }

      if (this.isProjectCompleted) {
        return 'green';
      }

      if (!this.project.dateFinish) {
        return '';
      }

      const today = new Date((new Date()).setHours(0, 0, 0, 0));
      const finish = new Date((new Date(this.project.dateFinish)).setHours(0, 0, 0, 0));
      const diffInDays = Math.ceil((finish - today) / (24 * 60 * 60 * 1000));

      if (diffInDays < 1) {
        return 'red';
      }

      if (diffInDays < 3) {
        return 'orange';
      }

      if (diffInDays < 7) {
        return 'yellow';
      }

      return '';
    },
    avatar() { return this.project.avatar?.thumbnails.avatar_large ?? '/img/avatar.png'; },
    params() {
      const area = this.project.objectArea;
      const price = this.project.pricePerSquareMeter;
      const cost = price ? (price * area).toFixed(0) : null;

      const items = [
        { icon: 'square', desc: 'площадь', value: area ? `${area} м<sup>2</sup>` : '— м<sup>2</sup>' },
        { icon: 'purse', desc: 'цена за м<sup>2</sup>', value: price ? `${price} ₽` : '— ₽' },
        { icon: 'cost', desc: 'стоимость', value: cost ? `${cost} ₽` : '— ₽' },
      ];

      return items.filter((item) => item.value);
    },
    ellipsisMenuItems() {
      const { access, project } = this;

      const onArchiveStateChanged = () => { this.$store.commit('project/setProject', { ...this.project, isArchived: !this.project.isArchived }); };
      const onRemoved = () => { this.$router.push({ name: 'project-list-archived' }); };

      return projectModel.getEllipsisMenu({
        access,
        project,
        onArchiveStateChanged,
        onRemoved,
        onProjectLeft: () => {},
        onCompanyDepartmentUpdated: () => {
          this.$store.dispatch('project/fetchProject', { projectId: this.project.id, force: true });
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.company-tile-xl {
  display: grid;
  grid-template-columns: 120px 1fr;
  grid-template-rows: max-content 1fr;
  column-gap: 30px;
  //row-gap: 20px;

  //row-gap: 5px;

  &__avatar {
    width: 100%;
    aspect-ratio: 1;
    height: auto;
    box-sizing: border-box;


    grid-column: 1;
    grid-row: 1 / 2 span;
  }

  &__name {
    //grid-column: 1;
    //grid-row: 2;
    //text-align: center;

    padding-top: 8px;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    grid-column: 2;
    grid-row: 1;
  }

  &__contacts {
    white-space: pre-line;
    //align-self: center;
    //grid-row: 1 / 2 span;

    grid-column: 2;
    grid-row: 2;
  }

  @media (max-width: 768px) {
    grid-column: 1 / 3 span;
    grid-template-columns: 44px 1fr;
    column-gap: 20px;
    row-gap: 0;
    //position: relative;
    //left: -64px;
    //margin-top: 5px;

    &__name {
      font-size: 20px;
      padding-top: 0;
    }

    &__contacts {
      font-weight: 400;
    }

    &__avatar {

      border-width: 2px;
      border-radius: 16px;
    }
  }

  @media (max-width: 576px) {
    &__name {
      font-size: 16px;
    }

    &__contacts {
      font-size: 12px;
    }
  }
}

.company-tile-sm {
  display: grid;
  grid-template-columns: 40px auto;
  column-gap: 15px;
  margin-bottom: 10px;

  &__avatar {
    width: 40px;
    height: 40px;
    border-width: 2px;
    border-radius: 16px;
    grid-row: 1 / 2 span;
  }

  &__company {
    font-size: 16px;
    font-weight: 700;
    line-height: 1.4;
  }


  &__company-only {
    font-size: 16px;
    font-weight: 700;
    line-height: 1.4;
    grid-row: 1 / 2 span;
    align-self: center;
  }

  &__department {
    font-size: 13px;
    font-weight: 400;
  }
}

.project-detail {
  padding-bottom: 84px;
  position: relative;

  &__container {
    display: grid;
    color: var(--color-white);
    gap: 40px;
    grid-template-columns: 120px 5fr 3fr;
    max-width: var(--container-size);
    margin: -20px auto 0;
    padding-left: var(--container-gutter);
    padding-right: var(--container-gutter);
  }
  &__image-wrap {
    display: block;
    grid-column: 1 span;
    width: 100%;
    box-sizing: border-box;
    position: relative;
    align-self: start;

    &:before {
      display: block;
      content: '';
      width: 0;
      padding-bottom: 100%;
    }
  }
  &__image {
    display: block;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  &__left {
    //grid-column: 5 span;
    display: flex;
    flex-direction: column;
    gap: 19px;
    padding: 8px;
  }
  &__title {
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
  }
  &__label {
    font-size: 12px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.03em;
    color: #FFFFFF;
    border-radius: 4px;
    padding: 0 14px;
    box-sizing: border-box;
    height: 20px;
    position: relative;
    top: 2px;

    &--green { background: #5AC169; }
    &--yellow { background: #F9D208; }
  }

  &__address {
    display: flex;
    font-style: normal;
    font-size: 14px;

    svg {
      display: block;
      flex-shrink: 0;
      width: 16px;
      height: 16px;
      padding-right: 4px;
      fill: var(--color-white);
    }
  }

  &__right {
    display: flex;
    flex-direction: column;
    //align-items: flex-end;
    justify-content: space-between;
    //grid-column: 5 span;
    //padding-top: 17px;
    width: 100%;
  }

  &__menu {
    display: flex;
    align-items: center;
    gap: 34px;
    position: absolute;
    top: -51px;
    right: 170px;
  }

  &__button {
    margin-top: auto;
    margin-left: auto;
  }

  &__progress-tooltip {
    position: absolute;
    z-index: 50;
    top: 30px;
    left: 50%;
    opacity: 0;
    padding: 8px 20px;
    visibility: hidden;
    transform: translateX(-50%);
    background-color: var(--color-white);
    color: var(--color-middle-gray);
    border-radius: 6px;
    box-shadow: 0 2px 30px rgba(0, 0, 0, 0.12);
    font-size: 14px;
    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
    &:before {
      content: "";
      display: inline-block;
      position: absolute;
      top: -16px;
      left: 50%;
      width: 32px;
      height: 16px;
      transform: translateX(-50%);
      background-image: url(../assets/img/svg/triangle.svg);
      background-size: cover;
      background-repeat: no-repeat;
    }
  }
  &__progress-container {
    margin-top: auto;
    position: relative;
    top: 5px;
    max-width: 535px;
    width: 100%;
  }
  &__progress-container:hover &__progress-tooltip {
    visibility: visible;
    opacity: 1;
  }

  @media (max-width: 1899.98px) {
    &__menu {
      top: -51px;
      right: 170px;
    }
  }

  @media (max-width: 1880px) {
    &__menu {
      //margin-right: calc(1508px - 80vw);
    }
  }

  @media (max-width: 1700px) {
    &__menu {
      //margin-right: 120px;
    }
  }

  @media (max-width: 1366px) {
    &__menu {
      top: -59px;
      right: 190px;
      //margin-right: 135px;
    }
  }

  @media (max-width: 1200px) {
    &__menu {
      right: 0;
      margin-right: 173px;
    }
  }

  @media (max-width: 768px) {
    &__menu {
      display: none;
    }
  }

  @media (max-width: 2300px) {
    &__container {
      margin-left:12vw;
    }
  }

  @media (max-width: 1700px) {
    &__container {
      margin-left: 0;
      max-width: none;
      padding: 0 40px;
      gap: 40px;
      grid-template-columns: 160px 6fr 2fr;
    }

    &__left {
      padding-left: 0;
    }
  }

  @media (max-width: 1500px) {
    &__container {
      grid-template-columns: 115px 6fr 2fr;
    }

    &__left {
      padding-left: 0;
    }
  }

  @media (max-width: 1200px) {
    padding-bottom: 48px;

    &__container {
      row-gap: 0;
      grid-template-columns: 115px 6fr 4fr;
    }
    &__image-wrap {
      grid-row: 2 span;
    }
  }

  @media (max-width: 1024px) {
    &__container {
      grid-template-columns: 60px 6fr 4fr;
      padding: 0 var(--container-gutter);
      gap:20px;
    }

    &__image-wrap {
      grid-column: 1 span;
    }

    &__image {
      border-width: 3px;
      border-radius: 20px;
    }
  }

  @media (max-width: 768px) {
    &__container {
      column-gap: 20px;
      row-gap: 15px;
      grid-template-columns: 44px 3fr 2fr;
      align-items: center;
    }

    &__image-wrap {
      grid-column: 1 span;
      grid-row: 2 span;
    }

    &__image {
      border-width: 2px;
      border-radius: 16px;
    }

    &__address {
      grid-row: 2;
      grid-column: 2 / 2 span;
    }

    &__title {
      grid-column: 2 / 2 span;
    }

    &__left {
      display: contents;
    }

    &__right  {
      display: contents;
    }

    &__company {
      grid-column: 1 / -1;
      grid-row: 3;

      .company-tile-sm {
        column-gap: 20px;
        margin-bottom: 0;
      }
    }

    &__progress-container {
      grid-column: 2 / 1 span;
      grid-row: 4;
    }

    &__button {
      grid-column: 3 / 1 span;
      grid-row: 4;
      align-self: end;

      ::v-deep .button {
        padding: 6px 10px;
        font-size: 12px;
        line-height: 1;
        height: auto;
      }
    }
  }

  @media (max-width: 576px) {
    &__container {
      grid-template-columns: 44px 3fr 4fr;
    }

    &__title {
      font-size: 16px;
    }

    &__progress-container {
      grid-column: 1 / 2 span;
      grid-row: 4;

      ::v-deep .progressbar__legend-item {
        font-size: 9px;
      }
    }
  }
}
</style>
